import React from 'react'
import { Tooltip } from 'antd'

const joinedIcon = () => {
  return (
    <Tooltip title="Joined">
        <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 0C5.20156 0 0.5 4.70156 0.5 10.5C0.5 16.2984 5.20156 21 11 21C16.7984 21 21.5 16.2984 21.5 10.5C21.5 4.70156 16.7984 0 11 0ZM11 19.2188C6.18594 19.2188 2.28125 15.3141 2.28125 10.5C2.28125 5.68594 6.18594 1.78125 11 1.78125C15.8141 1.78125 19.7188 5.68594 19.7188 10.5C19.7188 15.3141 15.8141 19.2188 11 19.2188Z" fill="#2563EB" />
            <path d="M11 10.5C12.3807 10.5 13.5 9.38071 13.5 8C13.5 6.61929 12.3807 5.5 11 5.5C9.61929 5.5 8.5 6.61929 8.5 8C8.5 9.38071 9.61929 10.5 11 10.5ZM11 11.5C8.33 11.5 3 12.84 3 15.5V16.5H19V15.5C19 12.84 13.67 11.5 11 11.5Z" fill="#2563EB" />
        </svg>
    </Tooltip>
  )
}

export default joinedIcon

